import { SUBMIT_FEEDBACK, SEND_FEEDBACK } from '../actions/feedbackForm';

export default (navigator, window) => {
    return {
        submitFeedback
    }
    function submitFeedback(store, next, action) {
        if (action.type === SUBMIT_FEEDBACK) {
            const { getState,  dispatch } = store; 
            const { userAgent = null } = navigator;
            const { location: { href:currentUrl = '' } = {} } = window;
            const { common: { auth: { username = null } = {} } = {} } = getState();

            if (userAgent && action.data ) {
                dispatch({type: SEND_FEEDBACK, data: {
                    ...action.data,
                    userAgent,
                    username,
                    currentUrl
                }})
            }
        }
        return next(action);
    }
}


// WEBPACK FOOTER //
// ./modules/Common/middleware/feedbackSubmit.js